import { Dispatch, SetStateAction, useState } from 'react';

interface Props {
  selectList: {
    label: string;
    value: string;
  }[];
  selectedValue: string;
  setSelectedValue: Dispatch<SetStateAction<string>>;
}

const SelectTag = ({ selectedValue, setSelectedValue, selectList }: Props) => {
  return (
    <div className="flex items-center gap-6 color-[">
      {selectList.map(list => (
        <button
          key={list.value}
          className={`leading-[-0.3px] text-[14px] px-16 py-8  border-1 text-center border-solid border-[#7750E9] rounded-22 text-[${
            selectedValue === list.value ? '#EAE8ED' : '#9170F2'
          }] ${selectedValue === list.value && 'bg-[#7750E9]'} ${
            list.value === 'view-count' && 'pl-11'
          }`}
          onClick={() => setSelectedValue(list.value)}
        >
          {list.label}
        </button>
      ))}
    </div>
  );
};

export default SelectTag;
